<template>
  <div class="container">
    <div class="thumbnail" style="float: left">
      <img :src="getimage()" width="70" height="70" />
    </div>
    <div style="float: left; margin-left: 10px;">
      <h6 v-if="ingredientInfo.ingredient.key">
        {{ $t(ingredientInfo.ingredient.key) }}
        {{ quantity != 0 ? quantity : "" }}
        {{ ingredientInfo.unit ? $t(ingredientInfo.unit.key) : null }}
      </h6>
    </div>

    <Button
      class="round-button p-button-danger"
      type="button"
      v-if="!updateMode"
      @click="deleteIngredient"
    >
      <i class="pi pi-times"></i>
    </Button>
    <Button
      class="round-button"
      type="button"
      @click="setUpdateModeTrue"
      v-if="!updateMode"
    >
      <i class="pi pi-pencil"></i>
    </Button>

    <Button
      class="p-button-outlined"
      style="float:right; margin-top:27px; margin-right:10px;"
      icon="pi pi-check"
      v-if="updateMode"
      @click="updateQuantityValue"
    ></Button>
    <InputNumber
      class="update-input"
      v-model="updatedQuantity"
      showButtons
      buttonLayout="horizontal"
      decrementButtonClass="p-button-danger"
      incrementButtonClass="p-button-success"
      incrementButtonIcon="pi pi-plus"
      decrementButtonIcon="pi pi-minus"
      v-if="updateMode"
      :min="0"
    />
  </div>
  <hr class="dashed" />
</template>

<script>
import StorageService from "../../service/StorageService.js";

export default {
  props: {
    ingredientInfo: Object,
    storageTypeId: Number,
  },
  data() {
    return {
      label: null,
      updatedQuantity: null,
      unitOfMeasure: null,
      updateMode: false,
      ingredientId: null,
      unitOfMeasureId: null,
      quantity: null,
    };
  },
  created() {
    this.storageService = new StorageService();
  },
  computed: {
    access_token: function() {
      return this.$store.getters["userdata/getAccessToken"];
    },
    user_id: function() {
      return this.$store.getters["profile/id"];
    },
    languages: function() {
      return this.$store.getters["labels/languages"];
    },
    storage: function() {
      return this.$store.getters["storage/getStorage"];
    },
    activeStorageId: function() {
      return this.$store.getters["storage/activeStorageId"];
    },
    visibleStorage: function() {
      return this.$store.getters["storage/visibleStorage"];
    },
    dataToSend: {
      get() {
        return this.$store.state.storage.dataToSend;
      },
      set(value) {
        return this.$store.commit("storage/setDataToSend", value);
      },
    },
  },
  mounted() {
    this.quantity = this.ingredientInfo.value;
    this.ingredientId = this.ingredientInfo.ingredient.id;
    this.updatedQuantity = this.quantity;
    this.importIngredientsTranslations(this.ingredientInfo, "ingredient");
    this.importIngredientsTranslations(this.ingredientInfo, "unit");
  },
  methods: {
    getimage() {
      let url = require("@/assets/flags/icons/ingredients.png");
      return this.ingredientInfo.ingredient.media === null
        ? url
        : this.ingredientInfo.ingredient.media[0].url;
    },
    setUpdateMode() {
      this.updateMode = true;
    },
    async updateQuantityValue() {
      let dataToSend = JSON.parse(JSON.stringify(this.dataToSend));
      let index = dataToSend.storage.findIndex((item) => {
        return item.storageType === this.activeStorageId;
      });
      let indexOfIngredient = dataToSend.storage[index].ingredients.findIndex(
        (item) => {
          return item.ingredient === this.ingredientInfo.ingredient.id;
        }
      );
      dataToSend.storage[index].ingredients[
        indexOfIngredient
      ].value = this.updatedQuantity;
      let responseCode = await this.storageService.setStorageInUser(
        this.access_token,
        this.user_id,
        dataToSend
      );
      if (responseCode == 200) {
        this.quantity = this.updatedQuantity;
        this.updateMode = false;
      }
      this.dataToSend = { ...dataToSend };
    },
    async deleteIngredient() {
      let dataToSend = JSON.parse(JSON.stringify(this.dataToSend));
      let index = dataToSend.storage.findIndex((item) => {
        return item.storageType === this.activeStorageId;
      });
      let indexOfIngredient = dataToSend.storage[index].ingredients.findIndex(
        (item) => {
          return item.ingredient === this.ingredientInfo.ingredient.id;
        }
      );
      dataToSend.storage[index].ingredients = dataToSend.storage[
        index
      ].ingredients.filter((item, index) => {
        return index != indexOfIngredient;
      });
      let ingredients = this.visibleStorage.ingredients.filter((item) => {
        return item.ingredient.id != this.ingredientInfo.ingredient.id;
      });
      this.$store.commit("storage/setIngredientsList", {
        index: index,
        ingredients: ingredients,
      });
      this.$store.commit("storage/setVisibleStorageIngredients", ingredients);
      await this.storageService.setStorageInUser(
        this.access_token,
        this.user_id,
        dataToSend
      );
      this.dataToSend = { ...dataToSend };
    },
    setUpdateModeTrue() {
      this.updateMode = true;
    },
    async importIngredientsTranslations(data, type) {
      let translations = new Array(this.languages.length);
      this.languages.forEach((elem, index) => {
        translations[index] = {};
        translations[index].locale = elem.code;
        translations[index].labels = {};
      });
      if (data[type]) {
        var path = data[type].key;
        data[type].labels.forEach((label) => {
          let index = translations.findIndex((x) => x.locale === label.locale);
          var value = label.value;
          var obj = translations[index].labels;
          var parts = path.split("."),
            part;
          var last = parts.pop();
          // eslint-disable-next-line no-cond-assign
          while ((part = parts.shift())) {
            if (typeof obj[part] != "object") obj[part] = {};
            obj = obj[part]; // update "pointer"
          }
          obj[last] = value;
        });
      }
      translations.forEach((elem) => {
        let old = this.$i18n.getLocaleMessage(elem.locale);
        this.$i18n.setLocaleMessage(elem.locale, this.merge(old, elem.labels));
      });
    },
    merge(a, b) {
      return Object.entries(b).reduce((o, [k, v]) => {
        o[k] =
          v && typeof v === "object"
            ? this.merge((o[k] = o[k] || (Array.isArray(v) ? [] : {})), v)
            : v;
        return o;
      }, a);
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  height: 90px;
  padding-left: 1%;
  position: relative;
}

h6 {
  font-size: 18px;
  font-weight: 500;
  margin-top: 36px;
}

.update-input {
  float: right;
  margin-right: 25px;
  margin-top: 27.5px;
}

.round-button {
  float: right;
  width: 40px;
  height: 40px;
  margin-right: 25px;
  padding: 0;
  margin-top: 25px;
}

hr.dashed {
  border-top: 1px dashed #98a6b4;
}

.thumbnail {
  margin-top: 10px;
  margin-right: 10px;
}
</style>
<style>
span.update-input
  input.p-inputtext.p-component.p-inputnumber-input.p-inputnumber-input {
  margin: 0;
  text-align: center;
  width: 50px;
}
</style>
